export default __webpack_public_path__ + "static/media/welcome-side-chrome.8a7b426c.png";